function getFullProblemId(moduleId, collectionId, problemId) {
    return `${moduleId}/${collectionId}/${problemId}`;
}

module.exports = getFullProblemId;
